{
    "Administrator": "Administrador:",
    "AdministratorRole": "Função de administrador:",
    "AdministratorLanguage_ServiceNotification": "Notificação de serviço:",
    "AdministratorLanguage_ConcurrentSignins": "Inícios de Sessão simultâneos permitidos:",
    "NAME": "AdministratorLanguage"
}